/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WidgetViewState {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return WidgetViewState.fixupPrototype; }

    static newInstance(model: Partial<WidgetViewState>): WidgetViewState {
        let obj = Object.assign(new WidgetViewState(), model);
        WidgetViewState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WidgetViewState>): WidgetViewState {
        if (!model) return null;
        return WidgetViewState.newInstance(<WidgetViewState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WidgetViewState) {
        if (!obj) return;

        models.WidgetViewState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WidgetViewState): boolean {
        switch (obj.__type)
        {
            case "ChartWidgetViewState":
                Object.setPrototypeOf(obj, models.ChartWidgetViewState.prototype);
                break;
            case "FilterWidgetViewState":
                Object.setPrototypeOf(obj, models.FilterWidgetViewState.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof WidgetViewState)[] {
        return [
            models.ChartWidgetViewState,
            models.FilterWidgetViewState,
        ];
    }

    fixupFields() {
    }

    id: string;

}
